import React, { FC } from 'react';
import '@components/shared/Agile/AgileBase.css';
import Text from '@amzn/meridian/text';
import { useAppContext } from '@components/agile/context/AppContext';

const WelcomePage: FC = () => {
  const { programType } = useAppContext();
  const welcomeMessage = `Welcome to ${programType}`;
  return (
    <div className="agile-home-container">
      <Text type="h600" alignment="center">
        {welcomeMessage}
      </Text>
    </div>
  );
};
export default WelcomePage;
